<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <a-tabs type="card" @change="callback">
        <a-tab-pane
          :key="item.kindCode"
          :tab="item.kindName"
          v-for="item in tabList"
        >
        </a-tab-pane>
      </a-tabs>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="名称"
                ><a-input v-model="queryParam.dictName" placeholder="名称"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="代码"
                ><a-input v-model="queryParam.dictCode" placeholder="代码"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">正常</a-select-option>
                    <a-select-option value="X">停用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >

                <a-button
                  type="primary"
                  class="button-margin-left"
                  v-hasAnyPermission="`dict:add`"
                  icon="plus"
                  @click="add"
                  >新建</a-button
                >

                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :isAuto="false"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" color="grey" v-if="record.sta == 'T'"
              >已停用</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`dict:edit`"
              >编辑</a
            >

            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`dict:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>
    <dict-info
      ref="districtInfo"
      @success="$refs.table.refresh(true)"
    ></dict-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import DictInfo from "./DictInfo.vue";

export default {
  name: "DictList",
  components: {
    STable,
    PageView,
    DictInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      tabList: [],
      tabKey: [],
      // 查询参数
      queryParam: {
        kindCode: ""
      },
      // 表头
      columns: [
        {
          title: "代码",
          dataIndex: "dictCode"
        },
        {
          title: "名称",
          dataIndex: "dictName",
          scopedSlots: { customRender: "tagItem" }
        },
        {
          title: "附加参数",
          dataIndex: "args"
        },
        {
          title: "排序",
          dataIndex: "listOrder"
        },
        {
          title: "备注",
          dataIndex: "remark",
          ellipsis: true
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          ellipsis: true
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageSystemDataDict(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.getDataKind();
  },
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.districtInfo.showModal(type, Object.assign({}, record));
      } else if (type == "del") {
        this.$http.systemBksApi
          .deleteSystemDataDictById({ id: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      }
    },
    add() {
      this.$refs.districtInfo.showModal("add", this.tabKey);
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    getDataKind() {
      this.$http.systemBksApi
        .listSystemDataKind({
          level: "BUSI",
          sta: "I"
        })
        .then(res => {
          this.tabList = res.resultObject;
          this.callback(this.tabList[0].kindCode);
        });
    },
    callback(key) {
      this.tabKey = key;
      this.queryParam.kindCode = key;
      this.$refs.table.refresh(true);
    },
    rest() {
      this.queryParam = {};
      this.queryParam.kindCode = this.tabKey;
    }
  }
};
</script>
